import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { verifyCertificate } from "../services/academyApi";
import { TrainingHero, TrainingLoading, TrainingError } from "./academy/AcademyShared";
import CareersFooter from "../components/CareersFooter";
import "./academy/academy.scss";

function VerifyShell({ children }) {
  return (
    <div className="training-center">
      <div className="training-center__bg" aria-hidden="true" />
      <div className="training-shell">
        <main className="training-body">{children}</main>
      </div>
      <CareersFooter />
    </div>
  );
}

export default function VerifyCertificatePage() {
  const { number } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    verifyCertificate(number)
      .then(setData)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [number]);

  if (loading) {
    return (
      <VerifyShell>
        <TrainingLoading label="Verifying certificate..." />
      </VerifyShell>
    );
  }

  if (error || !data) {
    return (
      <VerifyShell>
        <TrainingError
          title="Certificate not found"
          message="This certificate number could not be verified. Check the number and try again."
          action={
            <Link to="/academy" className="training-btn-secondary" style={{ marginTop: 12 }}>
              Browse programs
            </Link>
          }
        />
      </VerifyShell>
    );
  }

  const valid = data.valid && data.status === "issued";

  return (
    <VerifyShell>
      <TrainingHero
        eyebrow="QikTruck Careers"
        title={valid ? "Certificate verified" : "Certificate invalid"}
        subtitle={
          valid
            ? "This is an authentic QikTruck Academy credential."
            : `Status: ${data.status}`
        }
      />

      <div
        className={`training-cert-verify ${
          valid ? "training-cert-verify--valid" : "training-cert-verify--invalid"
        }`}
      >
        <dl className="training-cert-verify__list">
          <div>
            <dt>Recipient</dt>
            <dd>{data.recipient_name}</dd>
          </div>
          <div>
            <dt>Certification</dt>
            <dd>{data.certification_title}</dd>
          </div>
          <div>
            <dt>Program</dt>
            <dd>{data.academy_title}</dd>
          </div>
          <div>
            <dt>Issued</dt>
            <dd>
              {new Date(data.issued_at).toLocaleDateString("en-ZA", { dateStyle: "long" })}
            </dd>
          </div>
          <div>
            <dt>Certificate no.</dt>
            <dd>{data.certificate_number}</dd>
          </div>
        </dl>
      </div>

      <Link
        to="/academy"
        className="training-btn-secondary"
        style={{ marginTop: 16, display: "inline-flex" }}
      >
        QikTruck Careers Academy
      </Link>
    </VerifyShell>
  );
}
